// Single matching rule for list search and highlighting: literal, case-insensitive match of the trimmed term.
export function buildSearchRegex(term: string, flags = 'i'): RegExp | undefined {
  const trimmed = term.trim();
  if (!trimmed) {
    return undefined;
  }
  // Escape regex special characters in the user-supplied search term
  return new RegExp(trimmed.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`), flags);
}
